export default {
  home: {
    title: 'Home',
    search: 'Search websites...',
    popularSearch: 'Popular Searches',
    categories: 'Categories',
    featuredSites: 'Featured Sites',
    articles: 'Recommended Articles',
    submitSite: 'Submit Site',
  },
  category: {
    hotRecommend: 'Hot',
    newest: 'Newest',
    viewAll: 'View All',
    otherCategories: 'Other Categories',
  },
  article: {
    relatedArticles: 'Related Articles',
    backHome: 'Back to Home',
    shareTo: 'Share to',
  },
  about: {
    aboutUs: 'About Us',
    brandIntro: 'Brand Introduction',
    mission: 'Our Mission',
    vision: 'Our Vision',
    reputation: 'User Reviews',
    faq: 'FAQ',
    contactUs: 'Contact Us',
    sendMessage: 'Send Message',
    name: 'Name',
    email: 'Email',
    subject: 'Subject',
    message: 'Message',
  },
  footer: {
    quickLinks: 'Quick Links',
    hotCategories: 'Hot Categories',
    contact: 'Contact',
    rights: 'All Rights Reserved',
    privacy: 'Privacy Policy',
    terms: 'Terms of Use',
    sitemap: 'Sitemap',
  },
};